import type { Snapshot } from "@weather-deck/shared";
import { el } from "./dom";

export function buildHero(snap: Snapshot): HTMLElement {
  const s = snap.sensor as unknown as { temp?: number; measurements?: { temperature?: number } } | null;
  const c = snap.weather?.current as unknown as { temp?: number; temperature?: number } | null;
  const temp = s?.temp ?? s?.measurements?.temperature ?? c?.temp ?? c?.temperature;
  const tempText = temp != null ? `${temp.toFixed(1)}°` : "—";
  const time = new Date(snap.fetchedAt).toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" });
  return el("div", {}, [
    el("div", { className: "place", text: "Munich · Monolith MF Deck" }),
    el("div", { className: "temp", text: tempText }),
    el("div", { className: "place", text: `updated ${time}` })
  ]);
}
